(() => {
  if (window.PiurColorMediaGalleryLoaded) return;
  window.PiurColorMediaGalleryLoaded = true;

  const COMMON_COLOR_MEDIA = [
    {
      src: 'https://cdn.shopify.com/s/files/1/0990/2735/3982/files/Icons_a6ce26e8-a9e4-4897-b6d7-5aab9d9b1330.jpg?v=1781268716',
      alt: 'Produkteigenschaften',
    },
    {
      src: 'https://cdn.shopify.com/s/files/1/0990/2735/3982/files/Farbauswahl_48b3592a-5145-4a37-bab0-a68211eb20b6.png?v=1781268900',
      alt: 'Farbauswahl',
    },
  ];

  const COLOR_MEDIA = {
    altrosa: {
      images: [
        {
          src: 'https://cdn.shopify.com/s/files/1/0990/2735/3982/files/AdobeStock_490379208_Kopie_-_Copy.jpg?v=1781268673',
          alt: 'Lisboa Bettwaesche in Altrosa',
        },
        {
          src: 'https://cdn.shopify.com/s/files/1/0990/2735/3982/files/240710_PIUR_80x80_Lisboa-Altrosa_d97e47f1-25d1-469f-8818-a9ab64e0c813.jpg?v=1781268593',
          alt: 'Lisboa Altrosa Detail',
        },
        {
          src: 'https://cdn.shopify.com/s/files/1/0990/2735/3982/files/Lisboa_-_Altrosa.png?v=1781268586',
          alt: 'Lisboa Altrosa Produktbild',
        },
        ...COMMON_COLOR_MEDIA,
      ],
    },
    mint: {
      images: [
        {
          src: 'https://cdn.shopify.com/s/files/1/0990/2735/3982/files/IMG_1330_06417895-8661-487d-ba4a-6be010f65dcc.jpg?v=1783092829',
          alt: 'Male Mint Hauptbild',
        },
        {
          src: 'https://cdn.shopify.com/s/files/1/0990/2735/3982/files/piur-240710_PIUR_80x80_Male-Mint.webp?v=1783092882',
          alt: 'Male Mint Detail',
        },
        {
          src: 'https://cdn.shopify.com/s/files/1/0990/2735/3982/files/Male_-_Mintgruen.png?v=1783092831',
          alt: 'Male Mint Produktbild',
        },
        ...COMMON_COLOR_MEDIA,
      ],
    },
    hellblau: {
      preserveCurrentMain: true,
      images: [
        {
          src: 'https://cdn.shopify.com/s/files/1/0990/2735/3982/files/240710_PIUR_80x80_Iceland-Hellblau.jpg?v=1781271548',
          alt: 'Iceland Hellblau Detail',
        },
        {
          src: 'https://cdn.shopify.com/s/files/1/0990/2735/3982/files/Iceland_-_Hellblau.png?v=1781271547',
          alt: 'Iceland Hellblau Produktbild',
        },
        ...COMMON_COLOR_MEDIA,
      ],
    },
    hellgrau: {
      images: [
        {
          src: 'https://cdn.shopify.com/s/files/1/0990/2735/3982/files/Totale_hellgrau_0613db9d-bd2f-49eb-becb-77d5358071da.jpg?v=1781271819',
          alt: 'Manhattan Hellgrau Hauptbild',
        },
        {
          src: 'https://cdn.shopify.com/s/files/1/0990/2735/3982/files/240710_PIUR_80x80_Manhattan-Hellgrau.jpg?v=1781271824',
          alt: 'Manhattan Hellgrau Detail',
        },
        {
          src: 'https://cdn.shopify.com/s/files/1/0990/2735/3982/files/Manhattan_-_Hellgrau.png?v=1781271823',
          alt: 'Manhattan Hellgrau Produktbild',
        },
        ...COMMON_COLOR_MEDIA,
      ],
    },
    navyblau: {
      preserveCurrentMain: true,
      images: [
        {
          src: 'https://cdn.shopify.com/s/files/1/0990/2735/3982/files/240710_PIUR_80x80_Capri-Navyblau.jpg?v=1781272112',
          alt: 'Capri Navyblau Detail',
        },
        {
          src: 'https://cdn.shopify.com/s/files/1/0990/2735/3982/files/Capri-Navyblau.png?v=1781272111',
          alt: 'Capri Navyblau Produktbild',
        },
        ...COMMON_COLOR_MEDIA,
      ],
    },
    anthrazit: {
      images: [
        {
          src: 'https://cdn.shopify.com/s/files/1/0990/2735/3982/files/AdobeStock_186125043_Kopie.jpg?v=1783092829',
          alt: 'Fuji Anthrazit Hauptbild',
        },
        {
          src: 'https://cdn.shopify.com/s/files/1/0990/2735/3982/files/piur-240710_PIUR_40x80_Fuji-Anthrazit.webp?v=1783092881',
          alt: 'Fuji Anthrazit Detail',
        },
        {
          src: 'https://cdn.shopify.com/s/files/1/0990/2735/3982/files/Fuji_-_Anthrazit.png?v=1783092830',
          alt: 'Fuji Anthrazit Produktbild',
        },
        ...COMMON_COLOR_MEDIA,
      ],
    },
    taupe: {
      images: [
        {
          src: 'https://cdn.shopify.com/s/files/1/0990/2735/3982/files/taupe_2_550e52c4-98f8-4337-af58-bb0b27255f71.jpg?v=1781357508',
          alt: 'Paris Taupe Hauptbild',
        },
        {
          src: 'https://cdn.shopify.com/s/files/1/0990/2735/3982/files/240710_PIUR_80x80_Paris-Taupe.jpg?v=1781272208',
          alt: 'Paris Taupe Detail',
        },
        {
          src: 'https://cdn.shopify.com/s/files/1/0990/2735/3982/files/Paris_-_Taupe.png?v=1781272204',
          alt: 'Paris Taupe Produktbild',
        },
        ...COMMON_COLOR_MEDIA,
      ],
    },
    weiss: {
      images: [
        {
          src: 'https://cdn.shopify.com/s/files/1/0990/2735/3982/files/05_Weiss_1d707a60-fc7d-4f3d-ba6c-2c49757e8dc1.jpg?v=1781272312',
          alt: 'Santorin Weiss Hauptbild',
        },
        {
          src: 'https://cdn.shopify.com/s/files/1/0990/2735/3982/files/240710_PIUR_80x80_Santorin-Weiss.jpg?v=1781272312',
          alt: 'Santorin Weiss Detail',
        },
        {
          src: 'https://cdn.shopify.com/s/files/1/0990/2735/3982/files/Sanotrin_-_Weiss.png?v=1781272309',
          alt: 'Santorin Weiss Produktbild',
        },
        ...COMMON_COLOR_MEDIA,
      ],
    },
  };

  const COLOR_OPTION_NAMES = ['farbe', 'color'];
  const COLOR_MEDIA_ALIASES = {
    anthracite: 'anthrazit',
    fuji: 'anthrazit',
    mintgrun: 'mint',
    mintgruen: 'mint',
    male: 'mint',
  };
  const ORIGINAL_MARKUP = new WeakMap();
  const CUSTOM_ORIGINAL_MARKUP = new WeakMap();

  const normalize = (value) =>
    String(value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

  const escapeHtml = (value) =>
    String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');

  const cssEscape = (value) =>
    window.CSS?.escape ? window.CSS.escape(value) : String(value || '').replace(/[^a-zA-Z0-9_-]/g, '\\$&');

  const imageUrlWithWidth = (src, width) => {
    try {
      const url = new URL(src);
      url.searchParams.set('width', width);
      return url.toString();
    } catch (error) {
      return src;
    }
  };

  const srcset = (src, widths) => widths.map((width) => `${imageUrlWithWidth(src, width)} ${width}w`).join(', ');

  const getColorMediaConfig = (colorKey) => COLOR_MEDIA[colorKey] || null;

  const resolveColorImages = (colorKey, currentImage) => {
    const config = getColorMediaConfig(colorKey);
    if (!config) return [];

    const configuredImages = Array.isArray(config.images) ? config.images : [];
    if (!config.preserveCurrentMain) return configuredImages;

    return currentImage?.src ? [currentImage, ...configuredImages] : configuredImages;
  };

  const getDawnCurrentImage = (productInfo) => {
    const image =
      productInfo.querySelector('media-gallery .product__media-item.is-active img') ||
      productInfo.querySelector('media-gallery .product__media-list img');

    return image
      ? {
          src: image.currentSrc || image.src,
          alt: image.alt || '',
        }
      : null;
  };

  const getSelectedOptions = (productInfo) => {
    const options = [];

    productInfo.querySelectorAll('variant-selects [data-option-name]').forEach((optionGroup) => {
      const optionName = normalize(optionGroup.dataset.optionName);
      let selectedValue = '';

      const selectedRadio = optionGroup.querySelector('input[type="radio"]:checked');
      const select = optionGroup.querySelector('select');

      if (selectedRadio) {
        selectedValue = selectedRadio.value;
      } else if (select) {
        selectedValue = select.selectedOptions[0]?.value || select.value;
      }

      if (selectedValue) {
        options.push({ name: optionName, value: normalize(selectedValue) });
      }
    });

    return options;
  };

  const getSelectedColorKey = (productInfo) => {
    const selectedOptions = getSelectedOptions(productInfo);
    const colorOption = selectedOptions.find(({ name }) => COLOR_OPTION_NAMES.includes(name));

    if (colorOption) return getColorMediaKey(colorOption.value);

    return selectedOptions.map(({ value }) => getColorMediaKey(value)).find(Boolean) || '';
  };

  const getColorMediaKey = (optionValue) => {
    if (COLOR_MEDIA[optionValue]) return optionValue;
    if (COLOR_MEDIA_ALIASES[optionValue]) return COLOR_MEDIA_ALIASES[optionValue];
    if (optionValue.includes('anthracite') || optionValue.includes('fuji')) return 'anthrazit';

    const optionParts = optionValue.split(/[/|,;-]/).map(normalize);
    const matchingAlias = optionParts.map((part) => COLOR_MEDIA_ALIASES[part]).find(Boolean);
    if (matchingAlias) return matchingAlias;

    const matchingKey = Object.keys(COLOR_MEDIA).find((colorKey) => {
      const normalizedColorKey = normalize(colorKey);

      return optionParts.includes(normalizedColorKey) || optionValue.includes(normalizedColorKey);
    });

    return matchingKey || '';
  };

  const getPiurProductRoot = (node) => {
    let current = node;

    while (current && current !== document.documentElement) {
      if (current.tagName?.toLowerCase().startsWith('piur-product-')) return current;
      current = current.parentElement;
    }

    return null;
  };

  const getCustomProductRoots = () =>
    Array.from(document.querySelectorAll('[data-main-image]'))
      .map(getPiurProductRoot)
      .filter((root, index, roots) => root && roots.indexOf(root) === index);

  const scrollMediaIntoViewOnMobile = (root) => {
    if (!window.matchMedia('(max-width: 749px)').matches || !root) return;

    const target =
      root.querySelector('[data-main-image]') ||
      root.querySelector('media-gallery') ||
      root.querySelector('[id^="GalleryViewer"]');

    if (!target) return;

    window.setTimeout(() => {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }, 80);
  };

  const getCustomSelectedColorKey = (root) => {
    const colorSelector =
      root.querySelector('[data-option-selector][data-option-role="color"]') ||
      Array.from(root.querySelectorAll('[data-option-selector]')).find((selector) =>
        COLOR_OPTION_NAMES.includes(normalize(selector.dataset.optionName || selector.dataset.optionHandle || ''))
      );

    if (!colorSelector) return '';

    if (colorSelector.tagName === 'SELECT') {
      return getColorMediaKey(normalize(colorSelector.value || colorSelector.selectedOptions?.[0]?.value || ''));
    }

    const selectedButton =
      colorSelector.querySelector('[data-option-value].selected') ||
      colorSelector.querySelector('[data-option-value][aria-pressed="true"]') ||
      colorSelector.querySelector('[data-option-value][aria-current="true"]');

    return getColorMediaKey(normalize(selectedButton?.getAttribute('data-option-value') || ''));
  };

  const storeCustomOriginalMarkup = (root) => {
    const mainImage = root.querySelector('[data-main-image]');
    const thumbnails = root.querySelector('[data-thumbnails-container]');

    CUSTOM_ORIGINAL_MARKUP.set(root, {
      mainImage: mainImage?.innerHTML || '',
      thumbnails: thumbnails?.innerHTML || '',
      thumbnailsStyle: thumbnails?.getAttribute('style') || '',
    });
  };

  const getCustomCurrentImage = (root) => {
    const image = root.querySelector('[data-main-image] img');

    return image
      ? {
          src: image.currentSrc || image.src,
          alt: image.alt || root.currentProduct?.title || '',
        }
      : null;
  };

  const hasCustomProductMedia = (root) =>
    Boolean(root?.querySelector('[data-main-image] [data-piur-color-media="true"]'));

  const getCustomThumbnailClass = (root, index) => {
    const existingThumbnail = root.querySelector('[data-thumbnails-container] [data-thumbnail]');
    const fallback = 'piur-product-thumbnail';
    const baseClass = existingThumbnail?.className || fallback;

    return `${baseClass.replace(/\bactive\b/g, '').trim()}${index === 0 ? ' active' : ''}`;
  };

  const buildCustomThumbnail = (root, image, index) => `
    <div
      class="${getCustomThumbnailClass(root, index)}"
      data-thumbnail
      data-piur-color-media="true"
      data-image-url="${escapeHtml(imageUrlWithWidth(image.src, 1200))}"
      data-image-alt="${escapeHtml(image.alt)}"
      data-image-width="1200"
      data-image-height="1200"
    >
      <img
        src="${escapeHtml(imageUrlWithWidth(image.src, 200))}"
        alt="${escapeHtml(image.alt)}"
        width="200"
        height="200"
        loading="lazy"
      >
    </div>
  `;

  const applyCustomColorGallery = (root, colorKey, images) => {
    const mainImage = root.querySelector('[data-main-image]');
    const thumbnails = root.querySelector('[data-thumbnails-container]');
    if (!mainImage) return;

    if (root.dataset.piurColorKey === colorKey && hasCustomProductMedia(root)) return;
    if (!hasCustomProductMedia(root)) storeCustomOriginalMarkup(root);

    const featuredImage = images[0];
    if (typeof root.setMainImage === 'function') {
      root.setMainImage(imageUrlWithWidth(featuredImage.src, 1200), featuredImage.alt, 1200, 1200);
      root.querySelector('[data-main-image] img')?.setAttribute('data-piur-color-media', 'true');
    } else {
      mainImage.innerHTML = `
        <img
          src="${escapeHtml(imageUrlWithWidth(featuredImage.src, 1200))}"
          alt="${escapeHtml(featuredImage.alt)}"
          width="1200"
          height="1200"
          loading="eager"
          data-piur-color-media="true"
        >
      `;
    }

    if (thumbnails) {
      thumbnails.innerHTML = images.map((image, index) => buildCustomThumbnail(root, image, index)).join('');
      thumbnails.style.display = '';
      thumbnails.dataset.piurColorGallery = 'true';
    }

    root.dataset.piurColorGallery = 'true';
    root.dataset.piurColorKey = colorKey;
  };

  const restoreCustomGallery = (root) => {
    const originalMarkup = CUSTOM_ORIGINAL_MARKUP.get(root);
    if (!originalMarkup) return;

    const mainImage = root.querySelector('[data-main-image]');
    const thumbnails = root.querySelector('[data-thumbnails-container]');

    if (mainImage && hasCustomProductMedia(root)) mainImage.innerHTML = originalMarkup.mainImage;
    if (thumbnails && thumbnails.dataset.piurColorGallery === 'true') {
      thumbnails.innerHTML = originalMarkup.thumbnails;
      if (originalMarkup.thumbnailsStyle) {
        thumbnails.setAttribute('style', originalMarkup.thumbnailsStyle);
      } else {
        thumbnails.removeAttribute('style');
      }
      delete thumbnails.dataset.piurColorGallery;
    }

    delete root.dataset.piurColorGallery;
    delete root.dataset.piurColorKey;
  };

  const syncCustomProduct = (root) => {
    const colorKey = getCustomSelectedColorKey(root);
    const images = resolveColorImages(colorKey, getCustomCurrentImage(root));

    if (images.length) {
      applyCustomColorGallery(root, colorKey, images);
    } else if (hasCustomProductMedia(root)) {
      restoreCustomGallery(root);
    } else {
      storeCustomOriginalMarkup(root);
    }
  };

  const pendingCustomSyncs = new WeakSet();
  const scheduleCustomProductSync = (root) => {
    if (!root || pendingCustomSyncs.has(root)) return;
    pendingCustomSyncs.add(root);
    window.requestAnimationFrame(() => {
      pendingCustomSyncs.delete(root);
      syncCustomProduct(root);
    });
  };

  const storeOriginalMarkup = (productInfo) => {
    const gallery = productInfo.querySelector('media-gallery');
    const modalContent = productInfo.querySelector('product-modal .product-media-modal__content');

    ORIGINAL_MARKUP.set(productInfo, {
      gallery: gallery?.innerHTML || '',
      modalContent: modalContent?.innerHTML || '',
    });
  };

  const hasCustomGalleryItems = (gallery) =>
    Boolean(gallery?.querySelector('[id^="Slider-Gallery"] [data-media-id*="-piur-color-"]'));

  const hasCustomModalItems = (modalContent) =>
    Boolean(modalContent?.querySelector('[data-media-id^="piur-color-"]'));

  const restoreOriginalMarkup = (productInfo) => {
    const originalMarkup = ORIGINAL_MARKUP.get(productInfo);
    if (!originalMarkup) return;

    const gallery = productInfo.querySelector('media-gallery');
    const modalContent = productInfo.querySelector('product-modal .product-media-modal__content');

    if (gallery && gallery.dataset.piurColorGallery === 'true' && hasCustomGalleryItems(gallery)) {
      gallery.innerHTML = originalMarkup.gallery;
    }

    if (modalContent && modalContent.dataset.piurColorGallery === 'true' && hasCustomModalItems(modalContent)) {
      modalContent.innerHTML = originalMarkup.modalContent;
    }

    if (gallery) {
      delete gallery.dataset.piurColorGallery;
      delete gallery.dataset.piurColorKey;
      refreshGallery(gallery);
    }

    if (modalContent) delete modalContent.dataset.piurColorGallery;
  };

  const getSectionId = (productInfo, gallery) =>
    productInfo.dataset.section || gallery?.id?.replace('MediaGallery-', '') || 'main';

  const getBaseSlideClass = (gallery, index) => {
    const existingSlide = gallery.querySelector('.product__media-item');
    const fallback = 'product__media-item grid__item slider__slide';
    const baseClass = existingSlide?.className || fallback;

    return `${baseClass.replace(/\bis-active\b/g, '').trim()}${index === 0 ? ' is-active' : ''}`;
  };

  const getMediaFitClass = (gallery) => {
    const container = gallery.querySelector('.product-media-container');
    const mediaFitClass = Array.from(container?.classList || []).find((className) => className.startsWith('media-fit-'));

    return mediaFitClass || 'media-fit-cover';
  };

  const getConstrainClass = (gallery) =>
    gallery.querySelector('.product-media-container.constrain-height') ? ' constrain-height' : '';

  const getZoomClass = (gallery) => {
    const zoomButton = gallery.querySelector('.product__media-toggle');
    const zoomClass = Array.from(zoomButton?.classList || []).find((className) =>
      className.startsWith('product__media-zoom-')
    );

    return zoomClass || 'product__media-zoom-lightbox';
  };

  const getMediaIcon = (gallery) =>
    gallery.querySelector('.product__media-icon')?.outerHTML ||
    '<span class="product__media-icon motion-reduce quick-add-hidden" aria-hidden="true"></span>';

  const buildMainSlide = ({ image, index, sectionId, gallery, modalId }) => {
    const mediaId = `${sectionId}-piur-color-${index + 1}`;
    const loading = index === 0 ? 'eager' : 'lazy';
    const slideClass = getBaseSlideClass(gallery, index);
    const mediaFitClass = getMediaFitClass(gallery);
    const constrainClass = getConstrainClass(gallery);
    const zoomClass = getZoomClass(gallery);
    const mediaIcon = getMediaIcon(gallery);
    const alt = escapeHtml(image.alt);

    return `
      <li
        id="Slide-${mediaId}"
        class="${slideClass}"
        data-media-id="${mediaId}"
      >
        <div
          class="product-media-container media-type-image ${mediaFitClass} global-media-settings gradient${constrainClass}"
          style="--ratio: 1.0; --preview-ratio: 1.0;"
        >
          <modal-opener class="product__modal-opener product__modal-opener--image" data-modal="#${modalId}">
            ${mediaIcon}
            <div class="loading__spinner hidden"></div>
            <div class="product__media media media--transparent">
              <img
                srcset="${srcset(image.src, [246, 493, 600, 713, 823, 990, 1100, 1206, 1346, 1426, 1646, 1946])}"
                sizes="(min-width: 1200px) 715px, (min-width: 990px) 55vw, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)"
                src="${imageUrlWithWidth(image.src, 1100)}"
                alt="${alt}"
                loading="${loading}"
                width="1100"
                height="1100"
              >
            </div>
            <button
              class="product__media-toggle quick-add-hidden ${zoomClass}"
              type="button"
              aria-haspopup="dialog"
              data-media-id="piur-color-${index + 1}"
            >
              <span class="visually-hidden">Bild ${index + 1} oeffnen</span>
            </button>
          </modal-opener>
        </div>
      </li>
    `;
  };

  const buildThumbnail = ({ image, index, sectionId }) => {
    const mediaId = `${sectionId}-piur-color-${index + 1}`;
    const thumbnailId = `Thumbnail-${mediaId}`;
    const alt = escapeHtml(image.alt);

    return `
      <li
        id="Slide-Thumbnails-${mediaId}"
        class="thumbnail-list__item slider__slide"
        data-target="${mediaId}"
        data-media-position="${index + 1}"
      >
        <button
          class="thumbnail global-media-settings global-media-settings--no-shadow"
          aria-label="Bild ${index + 1} laden"
          ${index === 0 ? 'aria-current="true"' : ''}
          aria-controls="GalleryViewer-${sectionId}"
          aria-describedby="${thumbnailId}"
        >
          <img
            srcset="${srcset(image.src, [54, 74, 104, 162, 208, 324, 416])}"
            sizes="(min-width: 750px) 104px, calc((100vw - 8rem) / 3)"
            src="${imageUrlWithWidth(image.src, 208)}"
            alt="${alt}"
            loading="lazy"
            width="208"
            height="208"
            id="${thumbnailId}"
          >
        </button>
      </li>
    `;
  };

  const buildModalImage = ({ image, index }) => `
    <img
      class="global-media-settings global-media-settings--no-shadow${index === 0 ? ' active' : ''}"
      srcset="${srcset(image.src, [550, 1100, 1445, 1680, 2048, 2200, 2890, 4096])}"
      sizes="(min-width: 750px) calc(100vw - 22rem), 1100px"
      src="${imageUrlWithWidth(image.src, 1445)}"
      alt="${escapeHtml(image.alt)}"
      loading="lazy"
      width="1100"
      height="1100"
      data-media-id="piur-color-${index + 1}"
    >
  `;

  const updateImageRatios = (scope) => {
    scope.querySelectorAll('.product-media-container img').forEach((image) => {
      const updateRatio = () => {
        if (!image.naturalWidth || !image.naturalHeight) return;

        image.closest('.product-media-container')?.style.setProperty(
          '--preview-ratio',
          image.naturalWidth / image.naturalHeight
        );
      };

      if (image.complete) {
        updateRatio();
      } else {
        image.addEventListener('load', updateRatio, { once: true });
      }
    });
  };

  const refreshGallery = (gallery) => {
    gallery.elements = {
      liveRegion: gallery.querySelector('[id^="GalleryStatus"]'),
      viewer: gallery.querySelector('[id^="GalleryViewer"]'),
      thumbnails: gallery.querySelector('[id^="GalleryThumbnails"]'),
    };

    gallery.elements.viewer?.resetPages?.();
    gallery.elements.thumbnails?.resetPages?.();

    gallery.elements.thumbnails?.querySelectorAll('[data-target]').forEach((thumbnail) => {
      thumbnail.querySelector('button')?.addEventListener('click', () => {
        gallery.setActiveMedia?.(thumbnail.dataset.target, false);
      });
    });
  };

  const applyColorGallery = (productInfo, colorKey, images) => {
    const gallery = productInfo.querySelector('media-gallery');
    if (!gallery) return;

    const sectionId = getSectionId(productInfo, gallery);
    const modalId = `ProductModal-${sectionId}`;
    const viewerList = gallery.querySelector(`#Slider-Gallery-${cssEscape(sectionId)}`);
    const thumbnailList = gallery.querySelector(`#Slider-Thumbnails-${cssEscape(sectionId)}`);
    const modalContent = productInfo.querySelector(`#${cssEscape(modalId)} .product-media-modal__content`);

    if (!viewerList) return;
    if (gallery.dataset.piurColorKey === colorKey && hasCustomGalleryItems(gallery)) return;

    if (!hasCustomGalleryItems(gallery)) storeOriginalMarkup(productInfo);

    viewerList.innerHTML = images
      .map((image, index) => buildMainSlide({ image, index, sectionId, gallery, modalId }))
      .join('');

    if (thumbnailList) {
      thumbnailList.innerHTML = images.map((image, index) => buildThumbnail({ image, index, sectionId })).join('');
    }

    if (modalContent) {
      modalContent.innerHTML = images.map((image, index) => buildModalImage({ image, index })).join('');
      modalContent.dataset.piurColorGallery = 'true';
    }

    gallery.dataset.piurColorGallery = 'true';
    gallery.dataset.piurColorKey = colorKey;

    refreshGallery(gallery);
    updateImageRatios(gallery);
  };

  const syncProductInfo = (productInfo) => {
    const colorKey = getSelectedColorKey(productInfo);
    const images = resolveColorImages(colorKey, getDawnCurrentImage(productInfo));

    if (images.length) {
      applyColorGallery(productInfo, colorKey, images);
    } else {
      const gallery = productInfo.querySelector('media-gallery');

      if (hasCustomGalleryItems(gallery)) {
        restoreOriginalMarkup(productInfo);
      } else {
        if (gallery) {
          delete gallery.dataset.piurColorGallery;
          delete gallery.dataset.piurColorKey;
        }

        const modalContent = productInfo.querySelector('product-modal .product-media-modal__content');
        if (modalContent) delete modalContent.dataset.piurColorGallery;

        storeOriginalMarkup(productInfo);
      }
    }
  };

  const syncAllProductInfo = () => {
    document.querySelectorAll('product-info').forEach(syncProductInfo);
  };

  const syncAllCustomProducts = () => {
    getCustomProductRoots().forEach(syncCustomProduct);
  };

  const syncAll = () => {
    syncAllProductInfo();
    syncAllCustomProducts();
  };

  document.addEventListener('DOMContentLoaded', syncAll);
  document.addEventListener('change', (event) => {
    const productInfo = event.target.closest?.('product-info');
    if (productInfo && event.target.closest('variant-selects')) {
      window.setTimeout(() => syncProductInfo(productInfo));
      if (getSelectedColorKey(productInfo)) scrollMediaIntoViewOnMobile(productInfo);
      return;
    }

    const customProduct = getPiurProductRoot(event.target);
    if (customProduct && event.target.closest('[data-option-selector]')) {
      scheduleCustomProductSync(customProduct);
      if (event.target.dataset.optionRole === 'color') scrollMediaIntoViewOnMobile(customProduct);
    }
  });
  document.addEventListener('click', (event) => {
    const customProduct = getPiurProductRoot(event.target);
    if (!customProduct || !event.target.closest('[data-option-value]')) return;

    scheduleCustomProductSync(customProduct);
    const selector = event.target.closest('[data-option-selector]');
    if (selector?.dataset.optionRole === 'color') scrollMediaIntoViewOnMobile(customProduct);
  });
  document.addEventListener('product-info:variant-updated', (event) => syncProductInfo(event.target));
  document.addEventListener('variant:change', (event) => {
    const customProduct = getPiurProductRoot(event.target);
    if (customProduct) scheduleCustomProductSync(customProduct);
  });
  document.addEventListener('shopify:section:load', syncAll);
})();
